var _path, _g, _path2, _path3, _g2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendgrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5972_11654",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 35,
    width: 47,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0633 35.0625H12.1172V81.0086H58.0633V35.0625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5972_11654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1172 35.0625V58.0383H35.093V81.0086H58.0633V35.0625H12.1172Z",
    fill: "#00B2E3"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0485 58.0312H12.0781V81.0016H35.0485V58.0312Z",
    fill: "#1A82E2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5972_11654",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 12,
    width: 47,
    height: 47
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0008 12.0781H35.0547V58.0243H81.0008V12.0781Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5972_11654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.025 35.0485V12.0781H35.0547V35.0485V58.0243H58.025H80.9954V35.0485H58.025Z",
    fill: "#00B2E3"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.986 12.0859H58.0156V35.0563H80.986V12.0859Z",
    fill: "#1A82E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendgrid);
export default __webpack_public_path__ + "static/media/sendgrid.efb9fbfe3d96db06f2e25499f511d66f.svg";
export { ForwardRef as ReactComponent };